export * from './useDetailedMappingsByAssetIdQuery';
